import { Container, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { QRious } from 'react-qrious'

const useStyles = makeStyles((theme) => ({
    container: {
        textAlign: 'center',
    },
}))

export default function QRCode(props) {
    const { title, value } = props
    const classes = useStyles()

    return (
        <Container className={classes.container} maxWidth="xs">
            <QRious value={value} size={250} />
            <Typography variant="h5">{title}</Typography>
        </Container>
    )
}
